import { Theme } from "@mui/material/styles";
import { EventId } from "../interfaces/IEvent";
import { EventTypeShort } from "../interfaces/IEventEnums";
import { TemplateLanguage } from "../interfaces/IAlert";

/**
 * Formats a number into norwegian currency
 *
 * @param {number} value
 * @returns
 */
export const toCurrency = (value: number) => {
    return value.toLocaleString('nb-NO', {
        style: 'currency',
        currency: 'NOK',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/**
 * Formats a date object into norwegian date
 *
 * @param {Date} value
 * @returns
 */
export const toDate = (value: Date) => {
    return value.toLocaleDateString('nb-no', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
};

/**
 * Formats a date object into norwegian datetime
 *
 * @param {Date} value
 * @returns
 */
export const toDateTime = (value: Date) => {
    const dateTime = `${value.toLocaleDateString('nb-no', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    })} ${value.toLocaleTimeString('nb-no', {
        hour: '2-digit',
        minute: '2-digit',
    })}`;
    return dateTime;
};

export const splitEventId = (eventId: EventId) => {
    const [type, id] = [eventId.slice(0, 2), eventId.slice(2)];
    return { type, id };
};

export const eventIdType = (eventId: EventId) => {
    return splitEventId(eventId).type;
};

export const eventIdValue = (eventId: EventId) => {
    return splitEventId(eventId).id;
};

export const eventIdTextColor = (id: string, theme: Theme) => {
        if(eventIdType(id) === EventTypeShort.Planlagt){
            return theme.palette.eventType.planlagt;
        }
        if(eventIdType(id) === EventTypeShort.Fellesfeil){
            return theme.palette.eventType.fellesfeil;
        }
        if(eventIdType(id) === EventTypeShort.Generell){
            return theme.palette.eventType.generell;
        }
    }

export const getEstimatedDownTimeText = (estimatedDownTime: string, language: TemplateLanguage = TemplateLanguage.Norwegian) => {
    const [hours, minutes] = estimatedDownTime.split(':');

    const hoursNullOrEmpty = !hours || hours === '' || hours === '0';
    const minutesNullOrEmpty = !minutes || minutes === '' || minutes === '0';

    if (hoursNullOrEmpty && minutesNullOrEmpty) {
        return '';
    }

    const isEnglish = language === TemplateLanguage.English;
    const hoursText = hours > '1' ? (isEnglish ? 'hours' : 'timer') : (isEnglish ? 'hour' : 'time');
    const minutesText = minutes > '1' ? (isEnglish ? 'minutes' : 'minutter') : (isEnglish ? 'minute' : 'minutt');
    const and = isEnglish ? 'and' : 'og';

    if (hoursNullOrEmpty) {
        return `${minutes} ${minutesText}`;
    }
    if (minutesNullOrEmpty) {
        return `${hours} ${hoursText}`;
    }

    return `${hours} ${hoursText} ${and} ${minutes} ${minutesText}`;
}